import React, { Component, Fragment, useState } from 'react';
import DEFINE, {PATHS, FEATURE_FLAGS, HOMESTAY} from "../../../../constants/Define";
import CONFIG from '../../../../constants/Config';
import { generatePath, Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import HomestayRateList from './HomestayRateList';
import Ripple from '../../common/component/Ripple';
import { Button, Alert, message, Modal, List, Checkbox, Radio } from 'antd';
import update from 'immutability-helper';
import { isEqual } from 'lodash';
import { getContentLanguage } from '../../../../utils/commonUtils';
import Wrapper from '../../common/component/Wrapper';
import RenderHomestayisActive from '../Homestays/HomestayList/RenderHomestayisActive';
import {debounce} from 'lodash';
import SyncModal from './SyncModal/SyncModal';

const { confirm } = Modal

let permisionActions = [];

class PopUpConfirm extends Component{
    constructor(props){
        super(props);
        this.state = {
            replaceLanguage: 'vi-VN',
        }
    }
    onReplaceLanguageChange = e => {
        this.setState({ replaceLanguage: e.target.value });
        this.props.onSelected(e.target.value);
    }
    render(){
        const { t } = this.props;
        const noReplace = t('item.homestayRate.syncHomestayRateLanguage.noReplace');
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return(
            <Radio.Group onChange={this.onReplaceLanguageChange} value={this.state.replaceLanguage}>
                <Radio style={radioStyle} value={'vi-VN'}>{t(`translate.languages.vi`)}</Radio>
                <Radio style={radioStyle} value={'ko-KR'}>{t(`translate.languages.ko`)}</Radio>
                <Radio style={radioStyle} value={''}>{noReplace}</Radio>
            </Radio.Group>
        )
    }
}
export default class RoomTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            preHomestayId: this.props.match.params.homestay_id,
            filters: {
                homestayId: this.props.match.params.homestay_id,
                isActive: [true],
                pageSize: this.props.homestayRateState.pageSize,
                pageIndex: this.props.homestayRateState.pageIndex
            },
            isSort: false,
            isVisible: false,
            isVisibleSyncModal: false,
            homestayRates: [],
            homestayRatesActive: [],
            // isShowError: false
        };
        this.ChildElement = React.createRef();
        this.isCheckSync = true;
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RATEPLAN);
        this.props.getListHomestayRates(this.state.filters);
        if(this.state.filters?.homestayId){
            this.props.getHomestayDetail(this.state.filters.homestayId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.homestayRateState.isFetchSync){
            this.isCheckSync = true;
        }
        if (nextProps.homestayRateState.dataList && !isEqual(nextProps.homestayRateState.dataList, this.props.homestayRateState.dataList)) {
            this.setState({ homestayRates: nextProps.homestayRateState.dataList });
        }
        if(!isEqual(nextProps.homestayRateState.dataSync, this.props.homestayRateState.dataSync)){
            if(nextProps.homestayRateState.dataSync && nextProps.homestayRateState.dataSync.length > 0){
                this.setState({ isVisible: true});
            }else{
                this.setState({ isVisible: false});
            }
        }
        if(nextProps.homestayRateState.dataSyncLanguage && !isEqual(nextProps.homestayRateState.dataSyncLanguage, this.props.homestayRateState.dataSyncLanguage) && !nextProps.homestayRateState.isSyncLanguageSuccess){
            if(nextProps.homestayRateState.dataSyncLanguage && Object.keys(nextProps.homestayRateState.dataSyncLanguage).length > 0){
                // this.setState({isShowError: true})
                this.showReplaceLanguageSync(nextProps.homestayRateState.dataSyncLanguage)
            }
        }
    }

    showConfirmSync = () => {
        this.setState({isVisibleSyncModal : true})
    }

    handleOkSyncModal = (homestayRateCodes) => {
        const { t, match, homestayRateState } = this.props;
        this.setState({isVisibleSyncModal : false})
        if(this.isCheckSync){
            this.isCheckSync = false;
            this.props.syncHomestayRates(match.params.homestay_id, homestayRateCodes, true, this.state.filters);
        }
        // confirm({
        //     title: t('action.sync'),
        //     content:  <span>{t('item.homestayRate.confirmSync')}</span>,
        //     onOk: () => {
        //         if(this.isCheckSync){
        //             this.isCheckSync = false;
        //             this.props.syncHomestayRates(match.params.homestay_id, homestayRateCodes, true);
        //         }
        //         // debounce(() => {this.props.syncHomestayRates(match.params.homestay_id, true)}, 500)();
        //     },
        //     onCancel() {},
        //     okText: t(`action.sync`),
        //     cancelText: t(`action.cancel`)
        // });
    };

    showReplaceLanguageSync = (data) => {
        const { t, match } = this.props;
        const prefix = t('item.homestayRate.syncHomestayRateLanguage.confirmSyncLanguagePrefix');
        const suffix = t('item.homestayRate.syncHomestayRateLanguage.confirmSyncLanguageSuffix');
        const requesttLang = t(`translate.languages.${data.languageCodeNew.split('-')[0]}`);
        const currentLang = t(`translate.languages.${data.languageCodeOld.split('-')[0]}`);
        this.setState({replaceLanguage: 'vi-VN'});
        
        confirm({
            title: t('action.sync'),
            content:  <span>
                        <span>
                            {`${prefix} ${requesttLang}`}
                        </span> <br /> 
                        <span>
                            {`${suffix} ${currentLang}`}
                        </span>
                        <PopUpConfirm {...this.props} onSelected={this.onChangeReplaceLanguage}/>
                    </span>,
            onOk: () => {
                if(this.state.replaceLanguage)
                {
                    this.onSyncHomestayRateLanguage({
                        res: {
                            homestayId: data.homestayId,
                            homestayRatePlanId: data.homestayRatePlanId,
                            languageCodeNew: this.state.replaceLanguage,
                            languageCodeOld: data.languageCodeOld
                        }
                    });
                }
            },
            okText: t(`action.confirm`)
        })
    }

    onChangeReplaceLanguage = (replaceLanguage) => {
        this.setState({replaceLanguage: replaceLanguage})
    }

    handleOK = () => {
        this.setState({visible: false});
    }

    changStatusSynHomestayRateNew = ()=> {
        const { t, homestayRateState } = this.props;
        const { dataSync } = homestayRateState;
        const { isVisible } = this.state;
        return (
            <Modal className="surcharge-detail"
                destroyOnClose={true}
                visible={isVisible}
                width={800}
                title={t(`item.homestayRate.newHomestayRate.title`)}
                onOk={this.onSubmit} 
                okText={t(`action.update`)}
                onCancel={this.onCancel} 
                cancelText={t(`action.cancel`)}
            >
                <List
                    size="small"
                    dataSource={(dataSync || [])}
                    split={isVisible}
                    renderItem={(item, idx) => 
                        <List.Item className="row">
                                <Wrapper className="col-md-4">
                                    <Checkbox value={idx} onChange={(e)=>this.onChangeCheckBox(e.target.checked, idx)}>
                                        {item.name}
                                    </Checkbox>
                                </Wrapper>
                                <Wrapper className="col-md-3">
                                    {item.dc && 
                                        item.dc.map(typeId => <HMS.StatusComponent color={HOMESTAY.TYPE_RATE[CONFIG.ENV][typeId] === 'Bundle' ? 'geekblue' : 'red' }
                                        label={HOMESTAY.TYPE_RATE[CONFIG.ENV][typeId]} />)
                                    }
                                </Wrapper>
                                <Wrapper className="col-md-5">
                                    {item.description}
                                </Wrapper>
                        </List.Item>}
                    />
            </Modal>
        )
    }

    render() {
        const { t, match, homestayState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, dataList, isFetchSync, isFetchActive, isFetchExtend } = this.props.homestayRateState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex};
        const { isSort, homestayRates, isVisibleSyncModal } = this.state;

        return (
            <Fragment>
                {this.changStatusSynHomestayRateNew()}
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'homestayRate'}
                        titleHeader={`${t('navigation.homestayRates')} - ${homestayState?.detail?.homestay?.name || ""}`}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Wrapper style={{ display: 'flex' }}>
                                {/* <Wrapper style={{ display: 'flex' }}> */}
                                <RenderHomestayisActive onChangedHomestay={this.onChangeHomestay} defaultHomestayId={match.params.homestay_id} />
                                {/* </Wrapper> */}
                                {/* {
                                !isSort ? <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Button className='btn btn-primary' onClick={this.toggleSort}>{t(`action.sort`)}</Button>
                                </Ripple>
                                : <Fragment>
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Button className='btn btn-default mr-2' onClick={this.cancelSort}>{t(`action.cancel`)}</Button>
                                    </Ripple>
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Button className='btn btn-primary' disabled={isEqual(dataList, homestayRates)} onClick={this.applySortList}>{t(`action.save`)}</Button>
                                    </Ripple>
                                </Fragment>
                                } */}
                                {
                                    permisionActions && permisionActions.allowSync &&
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Button
                                            icon="sync"
                                            loading={isFetchSync}
                                            onClick={this.showConfirmSync}
                                            className='btn btn-primary ml-3'>
                                                {t(`action.sync`)}</Button>
                                    </Ripple>
                                }
                            </Wrapper>
                        }
                    />
                    <Alert message={t('notification.infoSort')} type="info" showIcon />
                    <HomestayRateList 
                        getListHomestayRates={() => this.props.getListHomestayRates(this.state.filters)}
                        loading={isFetching}
                        loadingStatus={isFetchActive}
                        loadingExtendHomestayRate={isFetchExtend}
                        homestayId={match.params.homestay_id}
                        permisions={permisionActions}
                        dataList={homestayRates}
                        filters={this.state.filters}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        isSort={isSort}
                        moveRow={this.moveRow}
                        onUpdateHomestayRateActive={this.onUpdateHomestayRateActive}
                        onSyncHomestayRateLanguage={this.onSyncHomestayRateLanguage}
                        onUpdateHomestayRateExtend={this.onUpdateHomestayRateExtend}
                        />
                </HMS.PageListComponent>

                {isVisibleSyncModal && 
                    <SyncModal 
                        visible={isVisibleSyncModal} 
                        setVisible={(visible) => {this.setState({isVisibleSyncModal: visible})}} 
                        handleOkSyncModal={this.handleOkSyncModal}
                        title={homestayState?.detail?.homestay?.name}
                    />}
            </Fragment>
        );
    }

    onChangeHomestay = (homestayId) => {
        if (homestayId) {
          const { filters } = this.state;
          let newFilters = Func.genaratePaginateFilterSort({}, filters, {});
          newFilters.homestayId = homestayId;
          newFilters.isActive = [true];
          newFilters.pageIndex = 1;
          this.setState({ filters: newFilters });
          this.props.getListHomestayRates(newFilters);
          this.props.getHomestayDetail && this.props.getHomestayDetail(homestayId);
          this.props.history.replace(generatePath(PATHS.HOMESTAY_RATE.LIST.path, {homestay_id: homestayId}));
        }
      };

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        if (!newFilters.isActive || !newFilters.isActive.length || newFilters.isActive[0] === '__all__') {
            delete newFilters.isActive;
        } else {
            newFilters.isActive = [newFilters.isActive[0] === 'true'];
        }
        newFilters.homestayId = this.props.match.params.homestay_id;
        this.setState({
            filters: newFilters
        });
        this.props.getListHomestayRates(newFilters);
    };

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && this.state.preHomestayId) {
            const path = Func.getPathWithParams(PATHS.HOMESTAY.DETAIL.path, { id: match.params.homestay_id })
            this.props.history.push(path);
        }
    }

    onChangeLanguage = (language) => {
        this.props.getListHomestayRates(this.state.filters)
    }

    onChangeCheckBox = (check, index)=>{
        const { homestayRatesActive } = this.state;
        if(check){
            this.setState({homestayRatesActive: [...homestayRatesActive, index]})
        }else{
            homestayRatesActive.splice(index, 1)
            this.setState({ homestayRatesActive });
        }
    }

    onCancel = ()=>{
        this.setState({isVisible: false});
    }

    onSubmit = ()=>{
        const { homestayRatesActive, filters } = this.state;
        const { t, homestayRateState } = this.props;
        const { dataSync } = homestayRateState;
        if(homestayRatesActive && homestayRatesActive.length > 0){
            const res = homestayRatesActive.map(item => {
                return{
                    id: dataSync[item].id,
                    usageStatus: true
                }
            })
            this.props.usageStatus({RatePlans: res}, filters);
            this.setState({isVisible: false});
        }
    }

    toggleSort = () => {
        if(this.state.homestayRates.length > 0) {
            this.setState({ isSort: true })
            message.info(this.props.t('notification.acceptSort'));
        }
    }

    cancelSort = () => {
        this.setState({ homestayRates: this.props.homestayRateState.dataList, isSort: false })
    }

    moveRow = (hoverIndex, dragFields, headSelect) => {
        // const { homestayRates } = this.state;
        // const dragRow = homestayRates[dragIndex];
        let lengthRows = dragFields.length;
        this.setState(
          update(this.state, {
            homestayRates: {
                $splice: [[headSelect, lengthRows], 
                [
                    ( lengthRows === 1 || hoverIndex < headSelect) ? hoverIndex : (hoverIndex - lengthRows) 
                    , 0, ...dragFields
                ]],
            },
          }),
        );
    };

    applySortList = () => {
        const { homestayRates } = this.state;
        const languageCode = getContentLanguage()
        const sortedHomestayRates = homestayRates.map((item, index) => ({ ratePlanId: item.id, languageCode, order: index }))
        this.props.sortHomestayRates(sortedHomestayRates, this.state.filters);
        this.setState({ isSort: false })
    }

    onUpdateHomestayRateActive = (obj)=> {
        const { filters } = this.state;
        this.props.updateHomestayRateActive({
            ...obj,
            filters: filters
        });
    }

    onUpdateHomestayRateExtend = (obj) => {
        const {filters} = this.state;
        this.props.updateHomestayRateExtend({
            ...obj,
            filters: filters
        })
    }

    onSyncHomestayRateLanguage = (obj) => {
        const { filters } = this.state;
        this.props.syncHomestayRateLanguage({
            ...obj,
            filters: filters
        })
    }
}
